import * as React from 'react';
import { CardContent, Typography } from '@mui/material';
import { useGetResourceLabel, useListContextWithProps, useResourceContext, useTranslate, } from 'ra-core';
import { Button } from '../button';
export var ListNoResults = function (props) {
    var translate = useTranslate();
    var resource = useResourceContext(props);
    var _a = useListContextWithProps(props), filterValues = _a.filterValues, setFilters = _a.setFilters;
    var getResourceLabel = useGetResourceLabel();
    if (!resource) {
        throw new Error('<ListNoResults> must be used inside a <List> component');
    }
    return (React.createElement(CardContent, null,
        React.createElement(Typography, { variant: "body2" }, filterValues &&
            setFilters &&
            Object.keys(filterValues).length > 0 ? (React.createElement(React.Fragment, null,
            translate('ra.navigation.no_filtered_results', {
                resource: resource,
                name: getResourceLabel(resource, 0),
                _: 'No results found with the current filters.',
            }),
            ' ',
            React.createElement(Button, { onClick: function () { return setFilters({}, []); }, label: translate('ra.navigation.clear_filters', {
                    _: 'Clear filters',
                }) }))) : (translate('ra.navigation.no_results', {
            resource: resource,
            name: getResourceLabel(resource, 0),
            _: 'No results found.',
        })))));
};
//# sourceMappingURL=ListNoResults.js.map